import "ng-file-upload/dist/ng-file-upload.min.js";

export default 'ngFileUpload';